import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getOrdersByItemNumber } from '../../../api/shipping/get-orders-by-item'

/* Initial state of the slice */
const initialState = {
  isFetchingOrderAllocations: false,
  orderAllocations: [],
  fetchOrderAllocationsError: null,
  totalRowsCount: null,
}
/* Handler for making service call to fetch Customer Group for a specific item */
export const fetchOrderAllocations = createAsyncThunk(
  'orderAllocations/fetchOrderAllocations',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      itemNumber: encodeURIComponent(state.inventory.selectedInventoryItem?.itemNumber),
      page: args.page,
      rowsPerPage: args.rowsPerPage,
      sortDirection: args.sortDirection,
      sortProperty: args.sortProperty,
    }
    try {
      const response = await getOrdersByItemNumber(request)
      return response
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const orderAllocationsSlice = createSlice({
  name: 'orderAllocations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderAllocations.pending, (state) => {
        state.isFetchingOrderAllocations = true
        state.orderAllocations = []
        state.fetchOrderAllocationsError = null
      })
      .addCase(fetchOrderAllocations.fulfilled, (state, action) => {
        state.isFetchingOrderAllocations = false
        state.orderAllocations = action.payload.data.data
        state.totalRowsCount = action.payload.headers.totalrows
      })
      .addCase(fetchOrderAllocations.rejected, (state, action) => {
        state.isFetchingOrderAllocations = false
        state.fetchOrderAllocationsError = action.payload
      })
      .addCase('inventory/fetchInventoryItems/pending', (state) => {
        state.orderAllocations = []
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default orderAllocationsSlice.reducer
